/**
 * Route guard: if the user is not authenticated, render the login page.
 *
 * The api/client redirects on 401 too, but a guard at the route level
 * avoids a flash of protected UI on first load (when /api/auth/me hasn't
 * resolved yet).
 */

import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";

import { useAuth } from "./AuthProvider";

export default function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <section className="page-section">
        <p className="empty-state">Loading…</p>
      </section>
    );
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <>{children}</>;
}
